export default __webpack_public_path__ + "static/media/bg_top_page.0fa2e8a9.jpg";